import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpMethod } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/message-service';
import { HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { Value } from '@philips-internal/oswald-ui-core/lib/types';

import BaseController from '../../BaseController';

import { Endpoint } from '../../../constants/endpoints';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';
import { BaseToastProps, ContextualBarAPI, ImageAPI, ModalAPI, PanelAPI, TextAPI, ToastAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';

@Controller({ component: 'layout-non-lab-exam-detail-images', fragment: 'non-lab-exam-detail-images' })
class NonLabExamDetailImagesController extends BaseController {

  @Inject('text-title')
  textTitle!: TextAPI;

  @Inject('toast-message')
  toastMessage!: ToastAPI;

  @Inject('contextual-bar-0')
  contextualBarApi!: ContextualBarAPI;

  @Inject('image-modal')
  imageModalApi!: ImageAPI;

  @Inject('panel-modal')
  panelModalApi!: PanelAPI;

  @Inject('modal-img')
  modalImgApi!: ModalAPI;

  @OnMount({ target: 'layout-non-lab-exam-detail-images' })
  onMount(): void {

    InformationBarUtils.collapsedBar = true;

    const { patientId, encounterId, nrSequencia, title } = this.historyService.getCurrentRouteParams();

    this.context.set({
      encounterId: encounterId,
      nrSequencia: nrSequencia,
      patientId: patientId,
    });

    this.contextualBarApi.setTitle((title ? title : ' ') as string);
  }

  preview(endpoint: string, parameters: Record<string, Value> = {}, method: HttpMethod = HttpMethod.GET, options: Record<string, string>): Promise<Blob> {
    return HttpService.fetch<Blob>({
      body: parameters,
      endpoint,
      headers: options,
      method: method,
    })
      .then((response: HttpResponse<Blob>) => {
        return response.body || new Blob();
      });
  }

  @OnClick({ target: 'deck-images' })
  onCardClick(event: ClickEvent): void {
    const { dsArquivoImagem } = event.value

    const patientId = this.context.get('patientId') as string;
    const encounterId = this.context.get('encounterId') as number

    this.preview(Endpoint.DOWNLOAD_NON_LAB_EXAM_IMAGE,
      {
        encounterId,
        path: dsArquivoImagem,
        patientId,
      },
      HttpMethod.GET,
      { headers: { 'accept': 'image/jpeg' } } as unknown as Record<string, string>)
      .then((response) => {
        const urlCreator = window.URL || window.webkitURL;
        const img = urlCreator.createObjectURL(response);
        this.panelModalApi.setVisible(true);
        this.imageModalApi.setSrc(img);
        this.modalImgApi.onClose.listen(() => this.panelModalApi.setVisible(false));
      })
      .catch(() => {
        const toast: BaseToastProps = {
          dismissible: true,
          id: 'file-not-found-toast',
          level: ToastLevel.WARNING,
          message: MessageService.translate('text.file-not-found'),
          showIcon: true,
          timeout: 5000,
          type: ToastType.BANNER,
        };
        ToastService.open(toast)
      });
  }
}

export default NonLabExamDetailImagesController;
